import { jsxs as e, jsx as l } from "react/jsx-runtime";
const t = (d) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...d,
    children: [
      /* @__PURE__ */ e(
        "g",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          clipPath: "url(#plug_disconnected_filled_svg__a)",
          children: [
            /* @__PURE__ */ l("path", { d: "m20 16-4 4" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "currentcolor",
                d: "m7 12 5 5-1.5 1.5a3.535 3.535 0 1 1-5-5zM17 12l-5-5 1.5-1.5a3.536 3.536 0 1 1 5 5z"
              }
            ),
            /* @__PURE__ */ l("path", { d: "m3 21 2.5-2.5M18.5 5.5 21 3M10 11l-2 2M13 14l-2 2M16 16l4 4" })
          ]
        }
      ),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "plug_disconnected_filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  t as default
};
